import uuid from 'uuid4';
import {planFactory} from '../factory/plan.factory';
import {productFactory} from '../factory/product.factory';
import {foodFactory} from '../factory/food.factory';
import {multiPortionFoodsManager} from "./MultiPortionFoodsManager";
import {ClipboardService} from "./clipboard/ClipboardService";
import {dayFactory} from "../factory/day.factory";
import {createTimestampFromDateAndTime} from "../utils/dateFormatter";

function recreatePlan(clipboardPlan, date, time) {
    return planFactory.create(
        uuid(),
        clipboardPlan.name,
        clipboardPlan.prescribedEnergy.amount,
        clipboardPlan.time,
        clipboardPlan.comment,
        clipboardPlan.foods.map((food) => {
            return foodFactory.create(
                uuid(),
                food.externalId,
                food.name,
                food.portions,
                null,
                food.hash,
                food.products.map((product) => {
                    return productFactory.create(
                        uuid(),
                        product.externalId,
                        product.name,
                        product.weight,
                        product.energy.amount,
                        product.category,
                        product.allergen,
                        product.disliked,
                        product.nutrients,
                        product.portion,
                    );
                }),
                food.portion,
                food.recipe,
                food.tags,
                food.diets,
                food.equipments,
                food.meals,
                food.repeating,
            );
        }),
        clipboardPlan.products.map((product) => {
            return productFactory.create(
                uuid(),
                product.externalId,
                product.name,
                product.weight,
                product.energy.amount,
                product.category,
                product.allergen,
                product.disliked,
                product.nutrients,
                product.portion,
            );
        }),
        createTimestampFromDateAndTime(date, time),
    );
}

export function copyProduct(productToCopy) {
    return productFactory.create(
        uuid(),
        productToCopy.externalId,
        productToCopy.name,
        productToCopy.weight,
        productToCopy.energy.amount,
        productToCopy.category,
        productToCopy.allergen,
        productToCopy.disliked,
        productToCopy.nutrients,
        productToCopy.portion,
    );
}

export function copyFood(foodToCopy) {
    const products = foodToCopy.products.map(p => copyProduct(p));

    return foodFactory.create(
        uuid(),
        foodToCopy.externalId,
        foodToCopy.name,
        foodToCopy.portions,
        foodToCopy.parentId,
        foodToCopy.hash,
        products,
        foodToCopy.portion,
        foodToCopy.recipe,
        foodToCopy.tags,
        foodToCopy.diets,
        foodToCopy.equipments,
        foodToCopy.meals,
        foodToCopy.repeating
    );
}

export function copyPlan(planToCopy, date, schema) {
    const plan = planFactory.create(
        uuid(),
        planToCopy.name,
        planToCopy.prescribedEnergy.amount,
        planToCopy.time,
        planToCopy.comment,
        [],
        [],
        date
    );

    if (planToCopy.products) {
        planToCopy.products
            .map(p => copyProduct(p))
            .map(p => plan.addProduct(p));
    }

    if (planToCopy.foods) {
        planToCopy.foods
            .map(food => {
                let newFood;
                if (food.isMultiPortionFood()) {
                    newFood = multiPortionFoodsManager.copyMultiPortionFood(food, schema);
                } else {
                    newFood = copyFood(food);
                }
                return newFood;
            })
            .map(f => plan.addFood(f));
    }

    return plan;
}

export function pasteDayFromClipboard(currentDay) {
    const clipboardItem = ClipboardService.getDay();
    let newDay = dayFactory.create(
        uuid(),
        currentDay.date,
        clipboardItem.day.comment,
        clipboardItem.day.plans.map((plan) => {
            return recreatePlan(plan, currentDay.date, plan.time);
        })
    );

    newDay.plans.forEach((newPlan) => {
       let currentPlan = currentDay.plans.find((currentPlan) => {
           return newPlan.name === currentPlan.name;
       });
       if (currentPlan !== undefined) {
           newPlan.products.forEach((newProduct) => {
              currentPlan.addProduct(newProduct);
           });
           newPlan.foods.forEach((newFood) => {
               currentPlan.addFood(newFood);
           });
       } else {
           currentDay.addPlan(newPlan);
       }
    });

    ClipboardService.removeDay();
}

export function pastePlanFromClipboard(currentPlan) {
    const clipboardItem = ClipboardService.getPlan();
    let newPlan = recreatePlan(clipboardItem.plan, currentPlan.date, currentPlan.time);
    newPlan.products.forEach((newProduct) => {
        currentPlan.addProduct(newProduct);
    });
    newPlan.foods.forEach((newFood) => {
        currentPlan.addFood(newFood);
    });
    ClipboardService.removePlan();
}
